export enum BuyGetStatus {
  Buy = 0,
  Get = 1,
  Neither = 2,
}
